export default __webpack_public_path__ + "ff93257c2113b2bf68e7be1ad9e80740.png";